/*重构登陆接口功能*/
import axios from '../index'
import api from './datasetLobby.api'

export default {
  /**
      * 公开数据集首页展示（分页加模糊查询） @data
      key:”String”, // 搜索关键词(数据集名称、行业领域)
		  status:”int”, // 数据集状态 0：未公开；1：已公开；2：所有
		  sort:”int”,	// 排序规则：0按时间降序，1按收藏降序，2按下载降序，3按引用降序，4按查看降序，5按收藏时间降序"
		  searchType:”int”	// 搜索类型：0公开数据，1个人上传，2个人收藏
		  datasetType: String	// 数据集类型：0全部数据类型，1为图像分类，2为物体检测，3为文本分类，4为文本标注，5为音频分类，6为音频标注
      pageNum:”int”, // 当前页数
      pageSize:”int”, // 分页大小
    */
  getDatasetHallList(data = {}) {
    return axios.post(api.getDatasetHallList, data)
  },
  /**
      * 是否公开数据集 @data
      datasetId:”String”,	// 数据集id
		  status:”int” // 公开状态，0未公开，1已公开
    */
  openPubDataset(data = {}) {
    return axios.post(api.openPubDataset, data)
  },
  /**
      * 是否收藏数据集 @data
      datasetId:”String”,	// 数据集id
		  status:”int” // 状态，0：未收藏，1：收藏
    */
  collectionPubDataset(data = {}) {
    return axios.post(api.collectionPubDataset, data)
  },
  /**
      * 上传数据集 @data
      datasetName:”String”,	// 数据集名称
			datasetContent:”String”, // 数据集简介
      datasetType:”String”,	// 数据集类型：1为图像分类，2为物体检测，3为文本分类，4为文本标注，5为音频分类，6为音频标注
      industryFieldArr: [], // industryFieldArr
      isPublic: 0, // 是否公开：0为不公开，1为公开
    */
  insertDataset(data = {}) {
    return axios.post(api.insertDataset, data)
  },
  /**
      * 修改数据集 @data
      datasetId: "String", // 数据集id
      datasetName:”String”,	// 数据集名称
			datasetContent:”String”, // 数据集简介
      datasetType:”String”,	// 数据集类型：1为图像分类，2为物体检测，3为文本分类，4为文本标注，5为音频分类，6为音频标注
      industryFieldArr: [], // industryFieldArr
      isPublic: 0, // 是否公开：0为不公开，1为公开
    */
  updateDataset(data = {}) {
    return axios.post(api.updateDataset, data)
  },
  /**
   ** 删除数据集 @data datasetId 数据集id
   */
  deletePubDataset(data = {}) {
    return axios.post(api.deletePubDataset, data)
  },
  /**
      * 根据数据集id获取数据集详情 @data {
          datasetHallType: 0, // 数据集大厅类型：0公开数据，1个人上传，2个人收藏
          datasetId: "String" // 数据集id,
          datasetName: "string", // 数据集名称
          idAdd: 0, // 是否增加查看数：0为不增加 1为增加
      * }
    */
  getDatasetInfoByDatasetId(data = {}) {
    return axios.post(api.getDatasetInfoByDatasetId, data)
  },
  /**
      * 根据数据集id获取数据集文件 @data {
        "datasetId": "string", // 数据集id
        "datasetType": "string", // 数据集类型：1为图像分类，2为物体检测，3为文本分类，4为文本标注，5为音频分类，6为音频标注
        "pageNum": 1,
        "pageSize": 10,
      }
    */
  getDatasetFileByDatasetId(data = {}) {
    return axios.post(api.getDatasetFileByDatasetId, data)
  },
  /**
      * 根据数据集id上传数据集文件 @data {
        "datasetId": "string", // 数据集id
        "datasetType": "string", // 数据集类型：1为图像分类，2为物体检测，3为文本分类，4为文本标注，5为音频分类，6为音频标注
        "list": [
          {
            "fileName": "string", // 文件名称
            "fileSize": 0, // 文件大小
            "fileUrl": "string" // 文件url
          }
        ],
      }
    */
  uploadFileByDatasetId(data = {}) {
    return axios.post(api.uploadFileByDatasetId, data)
  },
  /**
      * 根据文件id重命名数据集文件 @data {
        "datasetId": "string", // 数据集id
        "datasetType": "string", // 数据集类型：1为图像分类，2为物体检测，3为文本分类，4为文本标注，5为音频分类，6为音频标注
        "fileId": "string", // 文件id
        "fileName": "string" // 文件名称
      }
    */
  updateFileNameByFileId(data = {}) {
    return axios.post(api.updateFileNameByFileId, data)
  },
  /**
      * 根据文件id删除数据集文件 @data {
        "datasetId": "string", // 数据集id
        "datasetType": "string", // 数据集类型：1为图像分类，2为物体检测，3为文本分类，4为文本标注，5为音频分类，6为音频标注
        "fileId": "string", // 文件id
        "fileName": "string" // 文件名称
        "fileSize": 0 // 文件大小
      }
    */
  deleteFileByFileId(data = {}) {
    return axios.post(api.deleteFileByFileId, data)
  },
  /**
      * 批量删除数据集文件 @data {
        "datasetId": "string", // 数据集id
        "datasetType": "string", // 数据集类型：1为图像分类，2为物体检测，3为文本分类，4为文本标注，5为音频分类，6为音频标注
        "fileIds": [
          {
            fileId: "string", // 文件id
            fileSize: 0, // 文件大小
          }
        ],
        "isAll": 0, // 是否全部删除：0为部分删除，1为全部删除
      }
    */
  batchDeleteFile(data = {}) {
    return axios.post(api.batchDeleteFile, data)
  },
  /**
   * 查询行业领域 @data
   */
  getIndustryField(data = {}) {
    return axios.post(api.getIndustryField, data)
  },
  /**
      * 通过数据集ID下载文件 @data {
          datasetId: '', // 数据集id
          datasetName: '', // 数据集名称
          datasetType: '', // 数据集类型：1为图像分类，2为物体检测，3为文本分类，4为文本标注，5为音频分类，6为音频标注
      * }
    */
  downPubDataset(data = {},progressHandler) {
    // return axios.post(api.downPubDataset, data)
    return axios({
      method: 'post',
      url: api.downPubDataset,
      data: data,
      responseType: 'blob',
      onDownloadProgress:progressHandler
    })
  },
  /**
      * 查询引用数据集列表 @data {
        searchType: '0', // 搜索类型：0公开数据，1个人上传，2个人收藏
        datasetName: '', // 数据集名称
        datasetType: '', // 数据集类型：1为图像分类，2为物体检测，3为文本分类，4为文本标注，5为音频分类，6为音频标注
        pageNum: 1,
        pageSize: 10,
      * }
    */
  getQuoteDatasetList(data = {}) {
    return axios.post(api.getQuoteDatasetList, data)
  },
  /**
      * 添加引用数据集 @data {
        "datasetHallType": 0, // 数据集大厅类型：0公开数据，1个人上传，2个人收藏
        "datasetId": "string", // 目标数据集id
        "datasetType": "string", // 数据集类型
        "labelId": "string", // 分类标签id
        "list": [
          "string" // 被引用的数据集id集合
        ],
        "modFileNum": 0, // 目标数据集文件数
      }
    */
  quoteDataset(data = {}) {
    return axios.post(api.quoteDataset, data)
  },
  /**
      * 引用数据集详情添加文件 @data {
        "pubDatasetId": 0, // 当前数据集id
        "pubDatasetName": 0, // 当前数据集名称
        "datasetHallType": 0, // 数据集大厅类型：0公开数据，1个人上传，2个人收藏
        "datasetId": "string", // 目标数据集id
        "datasetType": "string", // 数据集类型
        "labelId": "string", // 分类标签id
        "list": [
          "string" // 被引用的数据集id集合
        ],
        "modFileNum": 0, // 目标数据集文件数
        "fileNum": 0, // 被引用的文件数量
        "type": 0, // 类型：0添加当前页，1添加所有
      }
    */
  quoteDatasetFile(data = {}) {
    return axios.post(api.quoteDatasetFile, data)
  },

  // /**
  //   * 通过数据集ID下载文件 @data
  //   “datasetId”:”String” // 数据集id
  // */
  // downloadDatesetFile(data = {}) {
  //     return axios.post(api.downloadDatesetFile, data)
  // },
  /**
   ** 获取数据类型 @data
   * "dictTypeCode": "DatasetType"
   */
  getComDictionary(data = {}) {
    return axios.post(api.getComDictionary, data)
  },
}
